import { http } from "../../utils/config";

const bannerAPI = {
  // Get banners for CMS
  getBanners: (params = {}) => {
    return http.get("/api/v1/banners", { params });
  },

  // Get banner by ID
  getBannerById: (id) => {
    return http.get(`/api/v1/banners/${id}`);
  },

  // Store new banner
  storeBanner: (formData) => {
    return http.post("/api/v1/banners", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // Update banner (Use POST to support file upload in multipart/form-data)
  updateBanner: (id, formData) => {
    return http.post(`/api/v1/banners/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // Delete banner
  deleteBanner: (id) => {
    return http.delete(`/api/v1/banners/${id}`);
  },

  // Toggle status
  toggleStatusBanner: (id) => {
    return http.patch(`/api/v1/banners/${id}/toggle-status`);
  },

  // Reorder banners
  reorderBanners: (ids) => {
    return http.post("/api/v1/banners/reorder", { ids });
  },

  // Public API for residents
  getPublicBanners: (params = {}) => {
    return http.get("/api/v1/auth/mini-app/banners", { params });
  },
};

// Helper functions for handling API responses
export const bannerHelpers = {
  extractBannerData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  extractBannerList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        banners: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  }
};

// Standard error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 400: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401: throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403: throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404: throw new Error('Không tìm thấy dữ liệu yêu cầu');
          case 422: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500: throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default: throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        throw new Error('Không thể kết nối đến server');
      } else {
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

export const bannerAPIWithErrorHandling = {
  getBanners: withErrorHandling(bannerAPI.getBanners),
  getBannerById: withErrorHandling(bannerAPI.getBannerById),
  storeBanner: withErrorHandling(bannerAPI.storeBanner),
  updateBanner: withErrorHandling(bannerAPI.updateBanner),
  deleteBanner: withErrorHandling(bannerAPI.deleteBanner),
  toggleStatusBanner: withErrorHandling(bannerAPI.toggleStatusBanner),
  reorderBanners: withErrorHandling(bannerAPI.reorderBanners),
  getPublicBanners: withErrorHandling(bannerAPI.getPublicBanners),
};

export default bannerAPI;
